import React, { useEffect, useRef, useState, useMemo } from "react";
import { formatMiles } from "../../../../utils/miles";
import {
  getFacturasProfesionalesByLiq,
  updateFacturaProfesional,
  addFacturaProfesional,
} from "../../../../api/ordenesDePagoApi";
import { getUsuarioById } from "../../../../api/usuarioApi";
import {
  getgastosbyliquidacion,
  AddGasto,
  getliquidacionbyid,   // ← NUEVO
} from "../../../../api/marcacionApi";
import { getidrecibo, InsertRecibo } from "../../../../api/marcacionApi";
import pdfrecibo from "../../liquidacion/services/pdfrecibo";
import { verifyOtpCode } from "../../../../api/OtpApi";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { FiEdit, FiCreditCard } from "react-icons/fi";
import "./sharedPagoStyles.css";
import * as XLSX from "xlsx"; // ⬅️ asegúrate de tener esta importación al inicio
const isPaid = (estado) => String(estado || "").trim().toUpperCase() === "PAGADO";

/* =========================================================
 *  COMPONENTE PRINCIPAL
 * =======================================================*/
function Profesionales({
  profesionalesData = [],
  preloaded,
  idordendepago,
  fechainicio, // ← se siguen usando solo para el PDF de resumen (no para recibo)
  fechafin,
}) {
  const [loading, setLoading] = useState(false);
  const [generatingPdf, setGeneratingPdf] = useState(false);
  const [profesionales, setProfesionales] = useState({});
  const [collapsed, setCollapsed] = useState(false);
  const [metodoFilter, setMetodoFilter] = useState("ALL");
  const [profesionalFilter, setProfesionalFilter] = useState("");

  // Modales
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedLiquidacion, setSelectedLiquidacion] = useState(null);

  const [payModalOpen, setPayModalOpen] = useState(false);
  const [selectedPago, setSelectedPago] = useState(null);

  const [addGastoModalOpen, setAddGastoModalOpen] = useState(false);
  const [selectedLiqForGasto, setSelectedLiqForGasto] = useState(null);
  const [selectedUserForGasto, setSelectedUserForGasto] = useState(null);

  // Caches
  const usuariosCacheRef = useRef(new Map());
  const gastosCacheRef = useRef(new Map());
  const facturasCacheRef = useRef(new Map());
  const lastHashRef = useRef(null);

  const buildHash = (arr) =>
    arr
      .map(
        (p) =>
          `${p.idUsuario}|${p.idLiquidacion}|${p.monto}|${p.NombrePaciente || ""}`
      )
      .join(";");

  // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  // RECIBO (por liquidación)
  // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
  const handleDownloadRecibo = async (row, idUsuario) => {
  try {
    // 1) Validar método = CHEQUE
    const metodo = String(row?.metodo || "").trim().toUpperCase();
    if (metodo !== "CHEQUE") {
      Swal.fire(
        "No permitido",
        "Solo se puede emitir recibo cuando la liquidación tiene método de pago CHEQUE.",
        "info"
      );
      return;
    }

    // 2) Nombre del profesional
    const dataUser = await getUsuarioById(idUsuario);
    const nombreusuario =
      (Array.isArray(dataUser) && dataUser[0]?.Nombre) ||
      (Array.isArray(dataUser) && dataUser[0]?.nombre) ||
      `Usuario ${idUsuario}`;

    // 3) Monto del recibo = SOLO el total de ESA liquidación (sin descuentos)
    const total = Math.round(Number(row?.monto || 0));

    // 4) Fechas del recibo: vienen de getliquidacionbyid
    let inicio = "";
    let fin = "";
    try {
      const liq = await getliquidacionbyid(row.idLiquidacion);
      const liqObj = Array.isArray(liq) ? liq[0] || {} : liq || {};
      inicio = liqObj.fechainicio || "";
      fin = liqObj.fechafin || "";
    } catch {
      inicio = "";
      fin = "";
    }

    // 5) Nombre del paciente
    const nombrepaciente =
      row?.NombrePaciente || `Liquidación #${row.idLiquidacion}`;

    // 6) Consultar si ya existe el recibo
    let recs = await getidrecibo(idUsuario, row.idLiquidacion);
    if (Array.isArray(recs) && recs.length > 0) {
      const idrec = recs[0].idrecibo;
      const fechacreacion = new Date(recs[0].fechacreacion);
      pdfrecibo({
        nombrepaciente,
        NombreUsuario: nombreusuario,
        total,
        idrec,
        inicio,
        fin,
        fechacreacion,
      });
      return;
    }

    // ⚠️ Nuevo paso: pedir confirmación antes de crear uno nuevo
    const result = await Swal.fire({
      title: "Recibo no encontrado",
      text: "Todavía no se ha generado un recibo para esta liquidación. ¿Desea crear uno ahora?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Sí, crear recibo",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    });

    if (!result.isConfirmed) return;

    // 7) Insertar y volver a consultar
    await InsertRecibo({
      nombrepaciente,
      nombreusuario,
      total,
      iduser: idUsuario,
      id: row.idLiquidacion,
    });

    recs = await getidrecibo(idUsuario, row.idLiquidacion);
    const idrec = recs[0].idrecibo;
    const fechacreacion = new Date(recs[0].fechacreacion);

    pdfrecibo({
      nombrepaciente,
      NombreUsuario: nombreusuario,
      total,
      idrec,
      inicio,
      fin,
      fechacreacion,
    });

    Swal.fire("Recibo creado", "El recibo fue generado correctamente.", "success");
  } catch (err) {
    console.error("Error generando recibo profesional:", err);
    Swal.fire("Error", "No se pudo generar el recibo.", "error");
  }
};


  useEffect(() => {
    if (!profesionalesData?.length) {
      setProfesionales({});
      return;
    }
    const currentHash = buildHash(profesionalesData);
    if (currentHash === lastHashRef.current) return;
    lastHashRef.current = currentHash;

    let cancelado = false;
    const controller = new AbortController();

    const load = async () => {
      setLoading(true);
      try {
        const uniqueUsers = [
          ...new Set(profesionalesData.map((p) => p.idUsuario).filter(Boolean)),
        ];
        const uniqueLiquidaciones = [
          ...new Set(
            profesionalesData.map((p) => p.idLiquidacion).filter(Boolean)
          ),
        ];
        const uniqueUserLiqPairs = [
          ...new Set(
            profesionalesData
              .filter((p) => p.idUsuario && p.idLiquidacion)
              .map((p) => `${p.idUsuario}_${p.idLiquidacion}`)
          ),
        ];

        if (preloaded?.usuariosMap) {
          for (const [id, data] of Object.entries(preloaded.usuariosMap)) {
            usuariosCacheRef.current.set(Number(id), data);
          }
        }
        if (preloaded?.gastosMap) {
          for (const [liqId, gastos] of Object.entries(preloaded.gastosMap)) {
            gastosCacheRef.current.set(Number(liqId), gastos);
          }
        }
        if (preloaded?.facturasMap) {
          for (const [key, facturaData] of Object.entries(
            preloaded.facturasMap
          )) {
            facturasCacheRef.current.set(key, facturaData);
          }
        }

        const fetchWithRetry = async (fn, args, retries = 2) => {
          for (let i = 0; i < retries; i++) {
            try {
              return await fn(...args, { signal: controller.signal });
            } catch (error) {
              if (controller.signal.aborted) throw error;
              if (i === retries - 1) throw error;
              await new Promise((r) => setTimeout(r, 800));
            }
          }
        };

        const missingUsers = uniqueUsers.filter(
          (id) => !usuariosCacheRef.current.has(id)
        );
        await Promise.all(
          missingUsers.map(async (id) => {
            try {
              const data = await fetchWithRetry(getUsuarioById, [id]);
              let nombre = `Usuario ${id}`;
              if (Array.isArray(data) && data[0]) {
                nombre =
                  data[0].Nombre ||
                  data[0].nombre ||
                  data[0].NombreCompleto ||
                  nombre;
              }
              usuariosCacheRef.current.set(id, { nombre });
            } catch {
              if (cancelado || controller.signal.aborted) return;
              usuariosCacheRef.current.set(id, { nombre: `Usuario ${id}` });
              Swal.fire(
                "Error",
                `No se pudo cargar datos del usuario ${id}.`,
                "error"
              );
            }
          })
        );

        const missingGastos = uniqueLiquidaciones.filter(
          (idLiq) => !gastosCacheRef.current.has(idLiq)
        );
        await Promise.all(
          missingGastos.map(async (liqId) => {
            try {
              const gastos = await fetchWithRetry(getgastosbyliquidacion, [
                liqId,
              ]);
              gastosCacheRef.current.set(
                liqId,
                Array.isArray(gastos) ? gastos : []
              );
            } catch {
              if (cancelado || controller.signal.aborted) return;
              gastosCacheRef.current.set(liqId, []);
              Swal.fire(
                "Error",
                `No se pudo cargar gastos para liquidación ${liqId}.`,
                "error"
              );
            }
          })
        );

        const missingFacturas = uniqueUserLiqPairs.filter(
          (k) => !facturasCacheRef.current.has(k)
        );
        await Promise.all(
          missingFacturas.map(async (pairKey) => {
            const [idUsuario, idLiquidacion] = pairKey
              .split("_")
              .map(Number);
            try {
              const facturas = await fetchWithRetry(
                getFacturasProfesionalesByLiq,
                [idUsuario, idLiquidacion]
              );
              let factura = "-",
                metodo = "-",
                idfactura = null,
                estado = null,
                comprobante = null;
              if (Array.isArray(facturas) && facturas.length > 0) {
                factura = facturas[0].numerofactura || "-";
                metodo = facturas[0].metododepago || "-";
                idfactura = facturas[0].idfacturasprofesionales || null;
                estado = facturas[0].estado || null;
                comprobante = facturas[0].comprobante || null;
              }
              facturasCacheRef.current.set(pairKey, {
                factura,
                metodo,
                idfactura,
                comprobante,
                estado,
              });
            } catch {
              if (cancelado || controller.signal.aborted) return;
              facturasCacheRef.current.set(pairKey, {
                factura: "-",
                metodo: "-",
                idfactura: null,
                comprobante: null,
                estado: null,
              });
            }
          })
        );

        if (cancelado) return;

        const result = {};
        for (const entry of profesionalesData) {
          const {
            idUsuario,
            idLiquidacion,
            monto = 0,
            NombrePaciente = "",
          } = entry;
          if (!idUsuario || !idLiquidacion) continue;

          if (!result[idUsuario]) {
            const meta =
              usuariosCacheRef.current.get(idUsuario) || {
                nombre: `Usuario ${idUsuario}`,
              };
            result[idUsuario] = { nombre: meta.nombre, liquidaciones: [], gastos: [] };
          }

          let liq = result[idUsuario].liquidaciones.find(
            (l) => l.idLiquidacion === idLiquidacion
          );
          if (!liq) {
            const pairKey = `${idUsuario}_${idLiquidacion}`;
            const f = facturasCacheRef.current.get(pairKey) || {
              factura: "-",
              metodo: "-",
              idfactura: null,
              estado: null,
              comprobante: null,
            };
            liq = {
              idLiquidacion,
              NombrePaciente,
              factura: f.factura || "-",
              metodo: f.metodo || "-",
              idfactura: f.idfactura || null,
              estado: f.estado || null,
              comprobante: f.comprobante || null,
              monto: 0,
            };
            result[idUsuario].liquidaciones.push(liq);
          }
          liq.monto += Number(monto) || 0;
        }

        for (const idUsuario of Object.keys(result)) {
          const numericUserId = Number(idUsuario);
          for (const liq of result[idUsuario].liquidaciones) {
            const gastosLiq = gastosCacheRef.current.get(liq.idLiquidacion) || [];
            const gastosUsuario = gastosLiq.filter(
              (g) =>
                g.idUsuario === numericUserId &&
                (g.paraHonorario === "SI" || g.paraHonorario === "si")
            );
            gastosUsuario.forEach((g) => {
              result[idUsuario].gastos.push({
                gasto: g.gasto || "Gasto",
                factura: g.factura || "-",
                monto: Number(g.monto) || 0,
              });
            });
          }
        }

        for (const idUsuario of Object.keys(result)) {
          const p = result[idUsuario];
          p.totalLiquidaciones = p.liquidaciones.reduce(
            (a, l) => a + (l.monto || 0),
            0
          );
          p.totalGastos = p.gastos.reduce((a, g) => a + g.monto, 0);
          p.totalGeneral = p.totalLiquidaciones + p.totalGastos;

          const methodCounts = {};
          let totalRegistrosMetodo = 0;
          p.liquidaciones.forEach((l) => {
            const m = (l.metodo || "-").trim();
            if (m && m !== "-") {
              methodCounts[m] = (methodCounts[m] || 0) + 1;
              totalRegistrosMetodo++;
            }
          });
          if (totalRegistrosMetodo > 0) {
            let metodoPredominante = null;
            let countMax = 0;
            for (const [m, c] of Object.entries(methodCounts)) {
              if (c > countMax) {
                metodoPredominante = m;
                countMax = c;
              }
            }
            p.metodoPredominante = metodoPredominante;
            p.porcentajeMetodoPredominante =
              (countMax / totalRegistrosMetodo) * 100;
          } else {
            p.metodoPredominante = null;
            p.porcentajeMetodoPredominante = 0;
          }
        }

        if (!cancelado) {
          setProfesionales(result);
          setCollapsed(false);
        }
      } catch (e) {
        if (!cancelado && !controller.signal.aborted) {
          console.error("Error carga profesionales:", e);
          Swal.fire("Error", "Error al cargar datos de profesionales.", "error");
          setProfesionales({});
        }
      } finally {
        if (!cancelado) setLoading(false);
      }
    };

    load();
    return () => {
      cancelado = true;
      controller.abort();
    };
  }, [profesionalesData, preloaded]);

  const metodosDisponibles = useMemo(() => {
    const set = new Set();
    Object.values(profesionales).forEach((p) => {
      if (p.metodoPredominante) set.add(p.metodoPredominante);
      p.liquidaciones.forEach((l) => {
        const m = (l.metodo || "").trim();
        if (m && m !== "-") set.add(m);
      });
    });
    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [profesionales]);

  const filteredProfesionales = useMemo(() => {
    let base = profesionales;
    if (metodoFilter !== "ALL") {
      const filtered = {};
      for (const [id, prof] of Object.entries(profesionales)) {
        if (prof.metodoPredominante !== metodoFilter) continue;
        const liqFiltradas = prof.liquidaciones.filter(
          (l) => (l.metodo || "-") === metodoFilter
        );
        if (!liqFiltradas.length) continue;
        filtered[id] = {
          ...prof,
          liquidaciones: liqFiltradas,
          totalLiquidaciones: liqFiltradas.reduce(
            (a, l) => a + (l.monto || 0),
            0
          ),
          totalGastos: prof.totalGastos,
          totalGeneral:
            liqFiltradas.reduce((a, l) => a + (l.monto || 0), 0) +
            prof.totalGastos,
        };
      }
      base = filtered;
    }
    if (profesionalFilter.trim() !== "") {
      const filtered = {};
      for (const [id, prof] of Object.entries(base)) {
        if (
          prof.nombre
            .toLowerCase()
            .includes(profesionalFilter.trim().toLowerCase())
        ) {
          filtered[id] = prof;
        }
      }
      base = filtered;
    }
    return base;
  }, [profesionales, metodoFilter, profesionalFilter]);

  const recalcProfesional = (prof) => {
    const totalLiquidaciones = prof.liquidaciones.reduce(
      (a, l) => a + (l.monto || 0),
      0
    );
    const totalGastos = prof.gastos.reduce((a, g) => a + (g.monto || 0), 0);
    prof.totalLiquidaciones = totalLiquidaciones;
    prof.totalGastos = totalGastos;
    prof.totalGeneral = totalLiquidaciones + totalGastos;
    return prof;
  };

  const recalcMetodoPredominante = (prof) => {
    const methodCounts = {};
    let totalRegistrosMetodo = 0;
    prof.liquidaciones.forEach((l) => {
      const m = (l.metodo || "-").trim();
      if (m && m !== "-") {
        methodCounts[m] = (methodCounts[m] || 0) + 1;
        totalRegistrosMetodo++;
      }
    });
    if (totalRegistrosMetodo > 0) {
      let metodoPredominante = null;
      let countMax = 0;
      for (const [m, c] of Object.entries(methodCounts)) {
        if (c > countMax) {
          metodoPredominante = m;
          countMax = c;
        }
      }
      prof.metodoPredominante = metodoPredominante;
      prof.porcentajeMetodoPredominante =
        (countMax / totalRegistrosMetodo) * 100;
    } else {
      prof.metodoPredominante = null;
      prof.porcentajeMetodoPredominante = 0;
    }
    return prof;
  };

  /* ---------- Abrir modales ---------- */
  const openEditModal = (liquidacion, idUsuario) => {
    setSelectedLiquidacion({
      ...liquidacion,
      idUsuario,
      nombreProfesional:
        profesionales[idUsuario]?.nombre || `Usuario ${idUsuario}`,
      monto: liquidacion.monto || 0,
    });
    setModalOpen(true);
  };

  const openPayModal = (row, idUsuario) => {
    setSelectedPago({
      ...row,
      idUsuario,
      nombreProfesional:
        profesionales[idUsuario]?.nombre || `Usuario ${idUsuario}`,
      comprobante: row.comprobante || "",
      estado: row.estado || "PENDIENTE",
    });
    setPayModalOpen(true);
  };

  const openAddGastoModal = (liquidacion, idUsuario) => {
    setSelectedLiqForGasto({
      ...liquidacion,
      nombreProfesional:
        profesionales[idUsuario]?.nombre || `Usuario ${idUsuario}`,
    });
    setSelectedUserForGasto(idUsuario);
    setAddGastoModalOpen(true);
  };

  /* ---------- Guardados ---------- */
  const handleUpdateFactura = async (data) => {
    try {
      let response;
      if (data.idfactura) {
        response = await updateFacturaProfesional(data);
        if (response?.isSaved) {
          const pairKey = `${data.idusuario}_${data.idliquidacion}`;
          facturasCacheRef.current.set(pairKey, {
            factura: data.numerofactura || "-",
            metodo: data.metododepago || "-",
            idfactura: data.idfactura,
            comprobante: data.comprobante || null,
            estado: data.estado || null,
          });
          setProfesionales((prev) => {
            const up = { ...prev };
            const prof = up[data.idusuario];
            if (prof) {
              const liq = prof.liquidaciones.find(
                (l) => l.idLiquidacion === data.idliquidacion
              );
              if (liq) {
                liq.factura = data.numerofactura || "-";
                liq.metodo = data.metododepago || "-";
                liq.idfactura = data.idfactura ?? response?.id ?? liq.idfactura;
              }
              up[data.idusuario] = recalcMetodoPredominante(
                recalcProfesional(prof)
              );
            }
            return up;
          });
          setModalOpen(false);
          Swal.fire("Éxito", "Factura actualizada.", "success");
        }
      } else {
        const payload = {
          idusuario: data.idusuario,
          idliquidacion: data.idliquidacion,
          numeroFactura: data.numerofactura,
          monto: data.monto,
          metododepago: data.metododepago,
        };
        response = await addFacturaProfesional(payload);
        if (response?.isCreated) {
          const newId = response.id;
          const pairKey = `${data.idusuario}_${data.idliquidacion}`;
          facturasCacheRef.current.set(pairKey, {
            factura: data.numerofactura || "-",
            metodo: data.metododepago || "-",
            idfactura: newId,
            comprobante: null,
            estado: "PENDIENTE",
          });
          setProfesionales((prev) => {
            const up = { ...prev };
            const prof = up[data.idusuario];
            if (prof) {
              const liq = prof.liquidaciones.find(
                (l) => l.idLiquidacion === data.idliquidacion
              );
              if (liq) {
                liq.factura = data.numerofactura || "-";
                liq.metodo = data.metododepago || "-";
                liq.idfactura = newId;
              }
              up[data.idusuario] = recalcMetodoPredominante(
                recalcProfesional(prof)
              );
            }
            return up;
          });
          setModalOpen(false);
          Swal.fire("Éxito", "Factura creada.", "success");
        }
      }
    } catch (e) {
      console.error("Error guardando factura:", e);
      Swal.fire("Error", "No se pudo guardar la factura.", "error");
    }
  };

  const handleSavePago = async (data) => {
    try {
      const response = await updateFacturaProfesional(data);
      if (response?.isSaved) {
        const pairKey = `${data.idusuario}_${data.idliquidacion}`;
        facturasCacheRef.current.set(pairKey, {
          factura: data.numerofactura,
          metodo: data.metododepago,
          idfactura: data.idfactura,
          comprobante: data.comprobante,
          estado: data.estado,
        });
        setProfesionales((prev) => {
          const up = { ...prev };
          const prof = up[data.idusuario];
          if (prof) {
            const liq = prof.liquidaciones.find(
              (l) => l.idLiquidacion === data.idliquidacion
            );
            if (liq) {
              liq.comprobante = data.comprobante;
              liq.estado = data.estado;
            }
            up[data.idusuario] = recalcMetodoPredominante(prof);
          }
          return up;
        });
        setPayModalOpen(false);
        Swal.fire("Éxito", "Pago registrado correctamente.", "success");
      }
    } catch (e) {
      console.error("Error guardando pago:", e);
      Swal.fire("Error", "No se pudo guardar el pago.", "error");
    }
  };

  const handleDownloadPdf = () => {
    if (!Object.keys(filteredProfesionales).length) return;
    generateProfesionalesPdfAligned(
      filteredProfesionales,
      setGeneratingPdf,
      metodoFilter,
      idordendepago,
      fechainicio,
      fechafin
    );
  };
const handleDownloadExcel = () => {
  if (!Object.keys(filteredProfesionales).length) {
    Swal.fire("Error", "No hay datos para exportar a Excel.", "error");
    return;
  }

  // Crear el arreglo de datos
  const rows = Object.values(filteredProfesionales).map((prof) => ({
    Profesional: prof.nombre,
    "Método de Pago": prof.metodoPredominante || "-",
    "Monto Total": prof.totalGeneral || 0,
  }));

  // Crear hoja y libro Excel
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Profesionales");

  // Ajustar formato (opcional)
  const colWidths = [
    { wch: 30 },
    { wch: 20 },
    { wch: 15 },
  ];
  ws["!cols"] = colWidths;

  // Guardar archivo
  XLSX.writeFile(wb, `Profesionales_orden_pago_${idordendepago}.xlsx`);
};
  const isEmpty = !loading && Object.keys(filteredProfesionales).length === 0;

  const globalSummary = useMemo(() => {
    const profCount = Object.keys(filteredProfesionales).length;
    let liqRegs = 0,
      gastoRegs = 0,
      totalHonorarios = 0;
    Object.values(filteredProfesionales).forEach((p) => {
      liqRegs += p.liquidaciones.length;
      gastoRegs += p.gastos.length;
      totalHonorarios += p.totalGeneral || 0;
    });
    return { profCount, liqRegs, gastoRegs, totalHonorarios };
  }, [filteredProfesionales]);

  return (
    <div className="op-section theme-azul">
      <div className="profesionales-header">
        <div className="title-line">
          <span
            className="collapse-icon"
            role="button"
            aria-label={collapsed ? "Expandir" : "Colapsar"}
            aria-expanded={!collapsed}
            onClick={() => setCollapsed((c) => !c)}
            title={collapsed ? "Mostrar detalle" : "Ocultar detalle"}
          >
            {collapsed ? "+" : "–"}
          </span>
          <h2 className="title-text">Profesionales</h2>
          <div className="summary-inline">
            <span>
              Profesionales: <strong>{globalSummary.profCount}</strong>
            </span>
            <span>
              Liquidaciones: <strong>{globalSummary.liqRegs}</strong>
            </span>
            <span>
              Gastos: <strong>{globalSummary.gastoRegs}</strong>
            </span>
            <span>
              Total: <strong>{formatMiles(globalSummary.totalHonorarios)}</strong>
            </span>
          </div>
        </div>
        <div className="header-actions">
          <div className="filtro-metodo-wrapper">
            <label
              htmlFor="metodoFilter"
              style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}
            >
              Método Predominante (solo liquidaciones)
            </label>
            <select
              id="metodoFilter"
              value={metodoFilter}
              onChange={(e) => setMetodoFilter(e.target.value)}
              className="metodo-select"
            >
              <option value="ALL">Todos</option>
              {metodosDisponibles.map((m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </div>

          <div className="filtro-profesional-wrapper">
            <label
              htmlFor="profesionalFilter"
              style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}
            >
              Profesional
            </label>
            <br />
            <input
              type="text"
              id="profesionalFilter"
              value={profesionalFilter}
              onChange={(e) => setProfesionalFilter(e.target.value)}
              placeholder="Buscar por nombre..."
              className="metodo-select"
              style={{ minWidth: "200px" }}
            />
          </div>
<button
  type="button"
  onClick={handleDownloadExcel}
  disabled={
    loading ||
    Object.keys(filteredProfesionales).length === 0
  }
  className="excel-btn"
>
  ⬇ Excel
</button>
          <button
            type="button"
            onClick={handleDownloadPdf}
            disabled={
              loading ||
              generatingPdf ||
              Object.keys(filteredProfesionales).length === 0
            }
            className="pdf-btn"
          >
            {generatingPdf ? (
              <>
                <span className="spinner-mini" /> Generando...
              </>
            ) : (
              <>
                <span style={{ fontSize: 16 }}>⬇</span> PDF
              </>
            )}
          </button>
        </div>
      </div>

      {loading && (
        <div className="loading-inline">
          <div className="spinner" />
          <span>Cargando profesionales...</span>
        </div>
      )}
      {isEmpty && !loading && <p>No hay profesionales para el filtro seleccionado.</p>}

      {!isEmpty && (
        <div
          className="detalle-wrapper"
          style={{
            maxHeight: collapsed ? 0 : undefined,
            overflow: "hidden",
            transition: "max-height .4s ease",
          }}
        >
          <div className="profesionales-grid">
            {Object.entries(filteredProfesionales)
              .sort((a, b) => a[1].nombre.localeCompare(b[1].nombre))
              .map(([idUsuario, prof]) => (
                <ProfessionalCard
                  key={idUsuario}
                  idUsuario={idUsuario}
                  prof={prof}
                  openEditModal={(row, uid) => openEditModal(row, uid)}
                  openPayModal={(row, uid) => {
                    if (!row.idfactura) {
                      Swal.fire(
                        "Falta factura",
                        "Debe cargar una factura antes de pagar.",
                        "info"
                      );
                      return;
                    }
                    openPayModal(row, uid);
                  }}
                  openAddGastoModal={(row, uid) => openAddGastoModal(row, uid)}
                  onRecibo={handleDownloadRecibo} // ← ahora por fila
                />
              ))}
          </div>
        </div>
      )}

      {/* Modales */}
      {modalOpen && selectedLiquidacion && (
        <EditFacturaModal
          liquidacion={selectedLiquidacion}
          onSave={handleUpdateFactura}
          onClose={() => setModalOpen(false)}
        />
      )}

      {payModalOpen && selectedPago && (
        <PagarFacturaModal
          pago={selectedPago}
          onSave={handleSavePago}
          onClose={() => setPayModalOpen(false)}
        />
      )}

      {addGastoModalOpen && selectedLiqForGasto && (
        <AddGastoModal
          liquidacion={selectedLiqForGasto}
          idUsuario={selectedUserForGasto}
          onSave={(g) => {
            setProfesionales((prev) => {
              const up = { ...prev };
              const p = up[g.idUsuario];
              if (p) {
                p.gastos.push({ gasto: g.gasto, factura: g.factura, monto: g.monto });
                up[g.idUsuario] = recalcProfesional(p);
              }
              return up;
            });
          }}
          onClose={() => setAddGastoModalOpen(false)}
        />
      )}
    </div>
  );
}

/* =========================================================
 *  SUBCOMPONENTES
 * =======================================================*/
function ProfessionalCard({
  idUsuario,
  prof,
  openEditModal,
  openPayModal,
  openAddGastoModal,
  onRecibo, // (row, idUsuario)
}) {
  return (
    <div className="profesional-card">
      <h3>
        {prof.nombre} (ID:{idUsuario})
        {prof.metodoPredominante && (
          <small>
            {" "}
            Método predominante: {prof.metodoPredominante} (
            {prof.porcentajeMetodoPredominante.toFixed(1)}%)
          </small>
        )}
      </h3>
      <DataTableLiquidaciones
        liquidaciones={prof.liquidaciones}
        idUsuario={idUsuario}
        openEditModal={openEditModal}
        openPayModal={openPayModal}
        openAddGastoModal={openAddGastoModal}
        onRecibo={onRecibo} // ← botón de recibo por fila
      />
      {!!prof.gastos.length && (
        <DataTableGastos
          gastos={prof.gastos}
          metodoPredominante={prof.metodoPredominante}
        />
      )}
      <div className="totales-box">
        <span>Total Honorarios</span>
        <span style={{ color: "red" }}>
          {formatMiles(prof.totalGeneral || 0)}
        </span>
      </div>
    </div>
  );
}

const COLUMN_WIDTHS = {
  concepto: "28%",
  factura: "15%",
  metodo: "15%",
  honorarios: "15%",
  estado: "12%",
  actions: "15%",
};
function ColumnGroup() {
  return (
    <colgroup>
      <col style={{ width: COLUMN_WIDTHS.concepto }} />
      <col style={{ width: COLUMN_WIDTHS.factura }} />
      <col style={{ width: COLUMN_WIDTHS.metodo }} />
      <col style={{ width: COLUMN_WIDTHS.honorarios }} />
      <col style={{ width: COLUMN_WIDTHS.estado }} />
      <col style={{ width: COLUMN_WIDTHS.actions }} />
    </colgroup>
  );
}

function DataTableLiquidaciones({
  liquidaciones,
  idUsuario,
  openEditModal,
  openPayModal,
  openAddGastoModal,
  onRecibo,
}) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="tabla-alineada">
        <ColumnGroup />
        <thead>
          <tr>
            <th>Liquidación</th>
            <th>Factura</th>
            <th>Método de Pago</th>
            <th>Honorarios</th>
            <th>Estado</th>
            <th>Opc.</th>
          </tr>
        </thead>
        <tbody>
          {liquidaciones.map((row) => {
            const locked = isPaid(row.estado);
            const isCheque = String(row.metodo || "").trim().toUpperCase() === "CHEQUE";
            return (
              <tr key={row.idLiquidacion}>
                <td data-label="Liquidación">
                  {row.NombrePaciente || `#${row.idLiquidacion}`}
                </td>
                <td data-label="Factura">{row.factura}</td>
                <td data-label="Método de Pago">{row.metodo}</td>
                <td data-label="Honorarios">{formatMiles(row.monto)}</td>
                <td
                  data-label="Estado"
                  className={locked ? "estado-pagado" : "estado-pendiente"}
                >
                  {row.estado || "-"}
                </td>
                <td data-label="Opciones">
                  <button
                    className="edit-btn"
                    onClick={() => openEditModal(row, idUsuario)}
                    title={
                      locked ? "Ver/Desbloquear con OTP" : "Ver/Editar factura"
                    }
                  >
                    <FiEdit />
                  </button>

                  <button
                    className="edit-btn"
                    onClick={() => openPayModal(row, idUsuario)}
                    disabled={!row.idfactura}
                    title={
                      !row.idfactura
                        ? "Debe cargar una factura antes de pagar"
                        : locked
                        ? "Ver/Desbloquear con OTP"
                        : "Pagar liquidación"
                    }
                  >
                    <FiCreditCard />
                  </button>

                  <button
                    className="edit-btn"
                    onClick={() => onRecibo(row, idUsuario)}
                    disabled={!isCheque}
                    title={
                      isCheque
                        ? "Descargar recibo (método CHEQUE)"
                        : "Solo disponible si la liquidación es CHEQUE"
                    }
                  >
                    🧾
                  </button>

                  <button
                    className="edit-btn"
                    onClick={() => openAddGastoModal(row, idUsuario)}
                    title={
                      locked
                        ? "Ver/Desbloquear con OTP"
                        : "Agregar Retención de IVA"
                    }
                  >
                    ➕
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function DataTableGastos({ gastos, metodoPredominante }) {
  return (
    <div style={{ overflowX: "auto" }}>
      <table className="tabla-alineada">
        <ColumnGroup />
        <thead>
          <tr>
            <th>Concepto</th>
            <th>Factura</th>
            <th>Método de Pago</th>
            <th>Honorarios</th>
          </tr>
        </thead>
        <tbody>
          {gastos.map((g, idx) => (
            <tr key={idx}>
              <td data-label="Concepto">{g.gasto || "-"}</td>
              <td data-label="Factura">{g.factura || "-"}</td>
              <td data-label="Método de Pago">{metodoPredominante || "-"}</td>
              <td data-label="Honorarios">{formatMiles(g.monto ?? 0)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

/* =========================================================
 *  MODALES CON OTP INTEGRADO
 * =======================================================*/
function OtpInline({ onUnlocked }) {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);

  const verify = async () => {
    const trimmed = code.trim();
    if (!/^\d{6}$/.test(trimmed)) {
      Swal.fire("Error", "Ingrese un código de 6 dígitos.", "error");
      return;
    }
    try {
      setBusy(true);
      await verifyOtpCode(trimmed);
      Swal.fire("Verificado", "Edición habilitada.", "success");
      onUnlocked();
    } catch (err) {
      const msg =
        err?.message ||
        err?.response?.data?.message ||
        "Código incorrecto o vencido.";
      Swal.fire("Error", msg, "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      style={{
        marginTop: 8,
        padding: 10,
        border: "1px dashed #cbd5e1",
        borderRadius: 8,
        background: "#f8fafc",
      }}
    >
      <Form.Label style={{ fontWeight: 600, fontSize: 12 }}>
        Desbloquear con OTP
      </Form.Label>
      <div style={{ display: "flex", gap: 8 }}>
        <Form.Control
          type="text"
          value={code}
          onChange={(e) =>
            setCode(e.target.value.replace(/\D/g, "").slice(0, 6))
          }
          placeholder="123456"
          style={{ maxWidth: 140 }}
        />
        <Button
          variant="secondary"
          onClick={verify}
          disabled={busy}
          title="Verificar y desbloquear"
        >
          {busy ? "..." : "🔒"}
        </Button>
      </div>
      <small style={{ color: "#64748b" }}>
        Ingrese el código y presione el candado para editar.
      </small>
    </div>
  );
}

function EditFacturaModal({ liquidacion, onClose, onSave }) {
  const [numeroFactura, setNumeroFactura] = useState(
    liquidacion.factura || ""
  );
  const [metodoDePago, setMetodoDePago] = useState(liquidacion.metodo || "");
  const [error, setError] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  const locked = isPaid(liquidacion.estado) && !unlocked;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (locked) return;
    if (!numeroFactura.trim() || !metodoDePago.trim()) {
      setError("Por favor, complete todos los campos.");
      return;
    }
    setError("");
    onSave({
      idfactura: liquidacion.idfactura,
      idusuario: Number(liquidacion.idUsuario),
      idliquidacion: liquidacion.idLiquidacion,
      numerofactura: numeroFactura,
      metododepago: metodoDePago,
      monto: liquidacion.monto || 0,
    });
  };

  return (
    <Modal show onHide={onClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{locked ? "Ver Factura" : "Editar Factura"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Profesional:</strong> {liquidacion.nombreProfesional}
          </p>
          <p>
            <strong>Liquidación:</strong>{" "}
            {liquidacion.NombrePaciente
              ? `${liquidacion.NombrePaciente} (#${liquidacion.idLiquidacion})`
              : `Liquidación #${liquidacion.idLiquidacion}`}
          </p>
          <p>
            <strong>Estado:</strong> {liquidacion.estado || "PENDIENTE"}
          </p>

          <Form.Group className="mb-3">
            <Form.Label>Número de Factura</Form.Label>
            <Form.Control
              type="text"
              value={numeroFactura}
              onChange={(e) => {
                const v = e.target.value;
                if (/^[0-9-]*$/.test(v)) setNumeroFactura(v);
              }}
              placeholder="Ej: 001-001-000153"
              disabled={locked}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Método de Pago</Form.Label>
            <Form.Control
              as="select"
              value={metodoDePago}
              onChange={(e) => setMetodoDePago(e.target.value)}
              disabled={locked}
            >
              <option value="">Seleccione un método</option>
              {["TRANSFERENCIA", "ACREDITACION_BANCARIA", "CHEQUE"].map(
                (m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                )
              )}
            </Form.Control>
          </Form.Group>

          {error && <p style={{ color: "red", fontSize: 12 }}>{error}</p>}
          {locked && (
            <>
              <p style={{ color: "#9ca3af", fontSize: 12 }}>
                Esta factura está pagada y no puede ser modificada.
              </p>
              <OtpInline onUnlocked={() => setUnlocked(true)} />
            </>
          )}
          {!locked && (
            <p style={{ color: "#16a34a", fontSize: 12 }}>
              🔓 Edición habilitada.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onClose}>
            Cerrar
          </Button>
          {!locked && (
            <Button type="submit" variant="success">
              Guardar
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

function PagarFacturaModal({ pago, onClose, onSave }) {
  const [comprobante, setComprobante] = useState(pago.comprobante || "");
  const [estado, setEstado] = useState(pago.estado || "PENDIENTE");
  const [unlocked, setUnlocked] = useState(false);

  const locked = isPaid(pago.estado) && !unlocked;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (locked) return;
    if (!pago.idfactura) {
      Swal.fire(
        "Error",
        "No se puede registrar un pago sin una factura cargada.",
        "error"
      );
      return;
    }
    onSave({
      idfactura: pago.idfactura,
      idusuario: pago.idUsuario,
      idliquidacion: pago.idLiquidacion,
      numerofactura: pago.factura,
      metododepago: pago.metodo,
      monto: pago.monto,
      comprobante,
      estado,
    });
  };

  return (
    <Modal show onHide={onClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>{locked ? "Ver Pago" : "Registrar Pago"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Profesional:</strong> {pago.nombreProfesional}
          </p>
          <p>
            <strong>Liquidación:</strong>{" "}
            {pago.NombrePaciente
              ? `${pago.NombrePaciente} (#${pago.idLiquidacion})`
              : `Liquidación #${pago.idLiquidacion}`}
          </p>
          <Form.Group className="mb-3">
            <Form.Label>Comprobante</Form.Label>
            <Form.Control
              type="text"
              value={comprobante}
              onChange={(e) => setComprobante(e.target.value)}
              placeholder="Ingrese número comprobante"
              disabled={locked}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Estado</Form.Label>
            <Form.Control
              as="select"
              value={estado}
              onChange={(e) => setEstado(e.target.value)}
              disabled={locked}
            >
              <option value="PENDIENTE">Pendiente</option>
              <option value="PAGADO">Pagado</option>
            </Form.Control>
          </Form.Group>

          {locked ? (
            <>
              <p style={{ color: "#9ca3af", fontSize: 12 }}>
                Esta liquidación está pagada y no puede modificarse.
              </p>
              <OtpInline onUnlocked={() => setUnlocked(true)} />
            </>
          ) : (
            <p style={{ color: "#16a34a", fontSize: 12 }}>
              🔓 Edición habilitada.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onClose}>
            Cerrar
          </Button>
          {!locked && (
            <Button type="submit" variant="success">
              Guardar
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

function AddGastoModal({ liquidacion, idUsuario, onClose, onSave }) {
  const [factura, setFactura] = useState("");
  const [monto, setMonto] = useState("");
  const [error, setError] = useState("");
  const [unlocked, setUnlocked] = useState(false);

  const locked = isPaid(liquidacion.estado) && !unlocked;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (locked) return;
    if (!factura.trim() || !monto.trim()) {
      setError("Debe ingresar factura y monto.");
      return;
    }
    setError("");

    const parsedMonto = Number(monto.replace(/\./g, "").replace(",", "."));
    if (isNaN(parsedMonto) || parsedMonto >= 0) {
      setError("El monto debe ser un número negativo válido.");
      return;
    }

    const objeto = {
      gasto: "Retención de IVA",
      idPaciente: liquidacion.idPaciente,
      idUsuario,
      idliquidacion: liquidacion.idLiquidacion,
      monto: parsedMonto, // negativo
      paciente:
        liquidacion.NombrePaciente ||
        `Paciente #${liquidacion.idPaciente}`,
      paraHonorario: "SI",
      paraTarifa: "NO",
      usuario:
        liquidacion.nombreProfesional || `Usuario ${idUsuario}`,
      fecha: new Date().toISOString().split("T")[0],
      hora: new Date().toLocaleTimeString(),
      metodo: "ADMINISTRATIVO",
      factura,
    };

    try {
      const saved = await AddGasto(objeto);
      if (saved) {
        Swal.fire("Éxito", "Gasto agregado correctamente.", "success");
        onSave(objeto);
        onClose();
      }
    } catch (err) {
      console.error("Error al guardar gasto:", err);
      Swal.fire("Error", "No se pudo guardar el gasto.", "error");
    }
  };

  return (
    <Modal show onHide={onClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar Retención de IVA</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            <strong>Profesional:</strong>{" "}
            {liquidacion.nombreProfesional || `Usuario ${idUsuario}`} ID{" "}
            {idUsuario}
          </p>
          <p>
            <strong>Liquidación:</strong> #{liquidacion.idLiquidacion}
          </p>

          <Form.Group className="mb-3">
            <Form.Label>Nro. Factura</Form.Label>
            <Form.Control
              type="text"
              value={factura}
              onChange={(e) => {
                const v = e.target.value;
                if (/^[0-9-]*$/.test(v)) setFactura(v);
              }}
              placeholder="Ej: 001-001-000153"
              disabled={locked}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Monto</Form.Label>
            <Form.Control
              type="text"
              value={monto}
              onChange={(e) => {
                if (locked) return;
                let raw = e.target.value.replace(/\./g, "").replace(",", "").trim();
                if (!raw) {
                  setMonto("");
                  return;
                }
                let num = parseInt(raw, 10);
                if (isNaN(num)) return;
                if (num > 0) num = -num; // siempre negativo
                setMonto(formatMiles(num));
              }}
              placeholder="Ej: -1.000"
              disabled={locked}
              required
            />
          </Form.Group>

          {error && <p style={{ color: "red", fontSize: 12 }}>{error}</p>}

          {locked ? (
            <>
              <p style={{ color: "#9ca3af", fontSize: 12 }}>
                La liquidación está pagada y no puede modificarse.
              </p>
              <OtpInline onUnlocked={() => setUnlocked(true)} />
            </>
          ) : (
            <p style={{ color: "#16a34a", fontSize: 12 }}>
              🔓 Edición habilitada.
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={onClose}>
            Cancelar
          </Button>
          {!locked && (
            <Button type="submit" variant="success">
              Guardar
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

/* =========================================================
 *  PDF (resumen)
 * =======================================================*/
function generateProfesionalesPdfAligned(
  profesionales,
  setGeneratingPdf,
  metodoFilter = "ALL",
  idordendepago,
  fechainicio,
  fechafin
) {
  if (!Object.keys(profesionales).length) {
    Swal.fire("Error", "No hay datos de profesionales para generar el PDF.", "error");
    return;
  }
  setGeneratingPdf(true);
  try {
    const doc = new jsPDF({ orientation: "p", unit: "pt", format: "a4", compress: true });
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const marginX = 28;
    let cursorY = 36;

    doc.setFont("helvetica", "bold").setFontSize(13)
      .text(`ORDEN DE PAGO #${idordendepago} - ${fechainicio || ""} - ${fechafin || ""}`, marginX, cursorY);
    cursorY += 14;
    const now = new Date();
    const fechaStr = now.toLocaleString();
    doc.setFont("helvetica", "normal").setFontSize(8).text(`Generado: ${fechaStr}`, marginX, cursorY);
    cursorY += 10;
    if (metodoFilter !== "ALL") {
      doc.setTextColor(30, 60, 120).text(`Filtro Método Predominante: ${metodoFilter}`, marginX, cursorY);
      doc.setTextColor(0, 0, 0);
      cursorY += 12;
    }

    const entries = Object.entries(profesionales).sort((a, b) => a[1].nombre.localeCompare(b[1].nombre));
    const headingFontSize = 10;
    const tableFontSize = 7.5;
    const lineGap = 4;

    entries.forEach(([idUsuario, prof], idx) => {
      if (!prof || !prof.nombre) return;
      if (cursorY > pageHeight - 120) { doc.addPage(); cursorY = 36; }
      doc.setFont("helvetica", "bold").setFontSize(headingFontSize);
      const metodoPredText = prof.metodoPredominante ? ` | Pred.: ${prof.metodoPredominante} (${prof.porcentajeMetodoPredominante?.toFixed(1)}%)` : "";
      doc.text(`${prof.nombre} (ID:${idUsuario})  Total: ${formatMiles(prof.totalGeneral || 0)}${metodoPredText}`, marginX, cursorY);
      cursorY += 12;

      if (prof.liquidaciones?.length) {
        doc.autoTable({
          startY: cursorY,
          margin: { left: marginX, right: marginX },
          styles: { fontSize: tableFontSize, cellPadding: 2, lineWidth: 0.1 },
          headStyles: { fillColor: [230, 235, 245], textColor: 20, lineWidth: 0.1 },
          bodyStyles: { lineWidth: 0.1 },
          theme: "grid",
          head: [["Liquidación", "Factura", "Método de Pago", "Honorarios", "Comprobante", "Estado"]],
          body: prof.liquidaciones.map(l => [
            l.NombrePaciente ? `${l.NombrePaciente} #${l.idLiquidacion}` : `#${l.idLiquidacion}`,
            l.factura || "-", l.metodo || "-", formatMiles(l.monto || 0),
            l.comprobante || "-", l.estado || "-"
          ]),
        });
        cursorY = doc.lastAutoTable.finalY + lineGap;
      }

      if (prof.gastos?.length) {
        if (cursorY > pageHeight - 80) { doc.addPage(); cursorY = 36; }
        doc.autoTable({
          startY: cursorY,
          margin: { left: marginX, right: marginX },
          styles: { fontSize: tableFontSize, cellPadding: 2, lineWidth: 0.1 },
          headStyles: { fillColor: [245, 245, 245], textColor: 40, lineWidth: 0.1 },
          bodyStyles: { lineWidth: 0.1 },
          theme: "grid",
          head: [["Concepto", "Factura", "Método de Pago", "Honorarios"]],
          body: prof.gastos.map(g => [
            g.gasto || "-", g.factura || "-", prof.metodoPredominante || "-", formatMiles(g.monto || 0)
          ]),
        });
        cursorY = doc.lastAutoTable.finalY + lineGap;
      }

      if (cursorY > pageHeight - 60) { doc.addPage(); cursorY = 36; }
      const totales = [
        `Total General: ${formatMiles(prof.totalLiquidaciones || 0)}`,
        `Total Deducciones: ${formatMiles(prof.totalGastos || 0)}`,
        `Total a Liquidar: ${formatMiles(prof.totalGeneral || 0)}`
      ];

      const boxWidth = 240;
      const boxHeight = 10 * totales.length + 10;
      doc.setDrawColor(60).setLineWidth(0.3).rect(marginX, cursorY, boxWidth, boxHeight);

      let innerY = cursorY + 12;
      totales.forEach((t, i) => {
        if (i === totales.length - 1) {
          doc.setFontSize(11).setFont("helvetica", "bold").setTextColor(220, 38, 38);
        } else {
          doc.setFontSize(8).setFont("helvetica", "normal").setTextColor(0, 0, 0);
        }
        doc.text(t, marginX + 6, innerY);
        innerY += 12;
      });

      doc.setTextColor(0, 0, 0);
      cursorY += boxHeight + 6;

      if (idx < entries.length - 1) {
        doc.setDrawColor(200).setLineWidth(0.3).line(marginX, cursorY, pageWidth - marginX, cursorY);
        cursorY += 15;
      }
    });

    const pageCount = doc.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.setFontSize(7).setTextColor(120)
        .text(`Página ${i} de ${pageCount}`, pageWidth - 80, pageHeight - 12);
    }
    const filtroSlug = metodoFilter === "ALL" ? "todos" : metodoFilter.replace(/\s+/g, "_");
    doc.save(`Profesionales_orden_pago_${idordendepago}_${filtroSlug}.pdf`);
  } catch (e) {
    console.error("Error generando PDF alineado:", e);
    Swal.fire("Error", "No se pudo generar el PDF.", "error");
  } finally {
    setGeneratingPdf(false);
  }
}

export default Profesionales;
